var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.22672 5.07422C2.0819 5.35103 2 5.66596 2 6.00002V16C2 17.1046 2.89543 18 4 18H12C12 14.6863 14.6863 12 18 12C19.5367 12 20.9385 12.5777 22 13.5278V6.00002C22 5.66596 21.9181 5.35103 21.7733 5.07422L13.577 10.8116C12.6301 11.4744 11.3699 11.4744 10.423 10.8116L2.22672 5.07422Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5731 4.08333C20.3916 4.02912 20.1992 4 20 4H4C3.80082 4 3.60844 4.02912 3.42688 4.08333L11.2832 9.58273C11.7136 9.88401 12.2864 9.88401 12.7168 9.58273L20.5731 4.08333Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15.2722C15.9251 13.6428 14 14.8448 14 16.5397C14 18.075 15.1544 18.9606 16.1372 19.7147L16.1648 19.7359C16.2574 19.807 16.3484 19.8769 16.4366 19.9461C16.8 20.2314 17.15 20.5 17.5 20.5C17.85 20.5 18.2 20.2314 18.5634 19.9461C19.5932 19.1377 21 18.2346 21 16.5397C21 15.9829 20.7922 15.4793 20.4574 15.1118C19.773 14.3606 18.5576 14.1781 17.5 15.2722Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageLove);
export default __webpack_public_path__ + "static/media/message-love.072164d5189ff442a277436dfc8fc56a.svg";
export { ForwardRef as ReactComponent };